<template>
<div class="vm-label" :class="[
    {'vm-label-bold': bold},
    {'vm-label-outside': outside},
    {'vm-label-topmargin': topMargin},
    {'vm-label-error': error},
]">

    <label>{{ text }}</label>

</div>
</template>
<script>

export default {
name: 'vm-label',
props: {
    text: {
        type: String,
        default: ''
    },
    bold: {
        type: Boolean,
        default: false
    },
    outside: {
        type: Boolean,
        default: false
    },
    topMargin: {
        type: Boolean,
        default: false
    },
    error: {
        type: Boolean,
        default: false
    }
},
data() {
    return {
        
    }
}
}
</script>
<style scoped>

.vm-label {
    margin-bottom: 3px;
    font-size: 14px;
}

.vm-label-bold {
    font-weight: bold;
}

.vm-label-error {
    color: #B62537;
}

.vm-label-outside {
    margin-left: 6px;
}

.vm-label-topmargin {
    float: left;
    margin-top: 12px;
}

</style>
